import { axiosApiService } from "./axios";

let allUserListPromise = null;

const StudentGetUser = {
    UserDetailsGet: async function (query) {
        const response = await axiosApiService.get(`/training/search_user/?q=${query}`);
        console.log((response));
        return response.data
    },
    AllUserListGet: async function(){
        if (!allUserListPromise) {
            allUserListPromise = axiosApiService.get(`/auth/users/`).then(res => {
                setTimeout(() => { allUserListPromise = null; }, 2000);
                return res;
            }).catch(err => {
                allUserListPromise = null;
                throw err;
            });
        }
        const response = await allUserListPromise;
        return response.data;
    },
    // SearchUsers: async function (query) {
    //     const response = await axiosApiService.get(`/training/search_user/?q=${query}`);
    //     console.log(response);
    //     return response.data
    // },
}
export default StudentGetUser;